<template>
  <v-container 
    id="caderno-servicos-historico" 
    tag="section"
    fluid>
    <v-row align="center">
      <v-col cols="12">
        <cadernos-servicos-data-table 
          :items="items"
          :loadingItems="loadingItems"
          @rechargeTable="getCadernosServicos()"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CadernosServicosService from "@/services/parametrosComCa/CadernosServicosService";
import dayjs from "dayjs";

export default {
  name: "IndexCadernosServicos",

  components: {
    CadernosServicosDataTable: () => import('@/components/parametrosComCa/cadernosServicos/CadernosServicosDataTable.vue'),
  },

  data() {
    return {
      items: [],
      loadingItems: false,
    };
  },

  mounted() {
    this.getCadernosServicos();
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  },

  methods: {
    getCadernosServicos() {
      this.loadingItems = true;

      CadernosServicosService.getCadernosServicos()
        .then(response => {
          this.items = [];
          response.data.cadernos.forEach(element => {
            this.items.push({
              id: element.id,
              nome: element.nome,
              usuario: element.usuario.nome,
              usuario_id: element.usuario.id,
              created: element.created ? dayjs(element.created).format("DD/MM/YYYY HH:mm") : "-",   
            });
          });
        })
        .catch(err => {
          this.$toast.error("Erro ao recuperar os Cadernos de Serviços.", "", { position: "topRight"});
          console.error(err);
        })
        .finally(() => this.loadingItems = false);
    }
  }
};
</script>


<style>
  
</style>